export const ORGANIZATION_NAME = "Nordisk Film+";

export const ORGANIZATION_PHONE_NUMBER = "+45 7070 7788";

export const ORGANIZATION_EMAIL = "kontakt@nordiskfilmplus.dk";
